import { Injectable } from "@angular/core";
import type { ProjectFormInitialValues } from "@domain/project/project-form-initial-values";
import type { ScopedProject } from "@domain/project/project-guards";
import { Observable, Subject } from "rxjs";

export type { ProjectFormInitialValues };
export type ProjectFormInitialization = ScopedProject | ProjectFormInitialValues;

@Injectable({
  providedIn: "root",
})
export class ProjectFormsService {
  private readonly _projectInitialized$ = new Subject<ProjectFormInitialization>();
  private readonly _projectReset$ = new Subject<ScopedProject>();

  get projectInitialized$(): Observable<ProjectFormInitialization | null> {
    return this._projectInitialized$.asObservable();
  }

  get projectReset$(): Observable<ScopedProject> {
    return this._projectReset$.asObservable();
  }

  initializeProject(project: ProjectFormInitialization) {
    this._projectInitialized$.next(project);
  }

  resetProject(project: ScopedProject) {
    this._projectReset$.next(project);
  }

  normalizeOptionalString(value: unknown): string | undefined {
    if (typeof value !== "string") return undefined;
    if (value === "") return undefined;
    return value;
  }
}
